//form表单样式
export const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {
        xs: {span:10,offset: 0},
        sm: {span:10,offset: 2},
        md: {span:10,offset: 2},
        lg: {span:10,offset: 2}
    }
};
//formItem样式
export const formItemTailLayout = {
    wrapperCol: {
        xs: 10,
        sm: {span:10,offset: 2},
        md: {span:10,offset: 2},
        lg: {span:10,offset: 2}
    }
};
//col组件样式
export const colLayout = {xs: 24, sm: 24, md: 12, lg: 12 };
//form表单按钮样式
export const buttonLayout = {wrapperCol: {offset: 10, span: 10},};
//textArea样式
export const textAreaLayout ={
    labelCol:{xs: 8, sm: 8, md: 4, lg: 4},
    wrapperCol:{
        xs: 8,
        sm: {span:10,offset: 2},
        md: {span:17,offset: 1},
        lg: {span:17,offset: 1}
    }
} ;
//RadioLayout样式
export const textRadioLayout ={
    labelCol:{xs: 8, lg: 4},
    wrapperCol:{
        xs: 8,
        sm: {span:10,offset: 1},
        md: {span:17,offset: 1},
        lg: {span:17,offset: 1}
    }
} ;

//fieldset样式
export const fieldsetStyle = {
    padding: '.35em .625em .75em',
    margin: '3px',
    border: '1px solid silver'
};

export const legendStyle = {
    padding: '.5em',
    border: 0,
    width: 'auto',
};
export const checkboxFormLayout = {
    wrapperCol: {
        xs: 20,
        sm: {span:20,offset: 2},
        md: {span:20,offset: 2},
        lg: {span:20,offset: 2}
    }
};
export const CustomerServiceLayout={
    xs: {span:2},
    sm: {span:2},
    md: {span:2},
    lg: {span:2}
};
export const indexSearchLayout={
    xs: {span:12},
    sm: {span:12},
    md: {span:14},
    lg: {span:14}
};
export const userImgLayout={
    xs: {span:10},
    sm: {span:10},
    md: {span:7},
    lg: {span:6}
};